// src/components/Shared/AIAssistantButton.js
import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebaseConfig';
import { IoSparklesOutline } from 'react-icons/io5';
import AIPreviewModal from './AIPreviewModal';

const AIAssistantButton = ({ textoOriginal, onSugerenciaAceptada, contexto, className, style }) => {
    const [loading, setLoading] = useState(false);
    const [sugerencia, setSugerencia] = useState('');
    const [showModal, setShowModal] = useState(false);

    const handleMejorarTexto = async () => {
        if (!textoOriginal || textoOriginal.trim().length < 5) {
            alert("Escribe al menos algunas palabras para que la IA pueda ayudarte.");
            return;
        }

        setLoading(true);
        try {
            const mejorarTextoIA = httpsCallable(functions, 'mejorarTextoIA');
            const result = await mejorarTextoIA({ textoOriginal, contexto });
            
            if (result.data.success && result.data.sugerencia) {
                setSugerencia(result.data.sugerencia);
                setShowModal(true);
            } else {
                alert("La IA no pudo procesar el texto.");
            }
        } catch (error) {
            console.error("Error llamando a IA:", error);
            alert("No se pudo conectar con el Asistente IA.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button 
                type="button"
                onClick={handleMejorarTexto}
                disabled={loading}
                className={className || "btn-neon"}
                style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    background: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)', 
                    color: 'white',
                    border: 'none',
                    padding: '8px 15px',
                    borderRadius: '8px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    boxShadow: '0 4px 10px rgba(168, 85, 247, 0.4)',
                    ...style 
                }}
                title="Generar magia con IA Gemini"
            >
                <IoSparklesOutline size={16} />
                {loading ? 'Pensando...' : 'Mejorar con IA'}
            </button>

            {showModal && (
                <AIPreviewModal 
                    textoOriginal={textoOriginal}
                    sugerencia={sugerencia}
                    onClose={() => setShowModal(false)}
                    onAceptar={() => {
                        onSugerenciaAceptada(sugerencia);
                        setShowModal(false);
                    }}
                />
            )}
        </>
    );
};

export default AIAssistantButton;
